var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BD0A28C5-2098-442E-A447-5E27F76D6B83@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cross",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal_readonly",
    transform: "translate(-1124.000000, -166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(1118.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,10.586 L16.243,6.343 C16.6334653,5.95253468 17.2665347,5.95253468 17.657,6.343 C18.0474653,6.73346532 18.0474653,7.36653468 17.657,7.757 L13.414,12 L13.414,12 L17.657,16.243 C18.0474653,16.6334653 18.0474653,17.2665347 17.657,17.657 C17.2665347,18.0474653 16.6334653,18.0474653 16.243,17.657 L12,13.414 L12,13.414 L7.757,17.657 C7.36653468,18.0474653 6.73346532,18.0474653 6.343,17.657 C5.95253468,17.2665347 5.95253468,16.6334653 6.343,16.243 L10.586,12 L10.586,12 L6.343,7.757 C5.95253468,7.36653468 5.95253468,6.73346532 6.343,6.343 C6.73346532,5.95253468 7.36653468,5.95253468 7.757,6.343 L12,10.586 L12,10.586 Z",
    id: "Path",
    fill: "currentColor"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.846861f036e8d6be0e96d635ab233b08.svg";
export { ForwardRef as ReactComponent };